import * as React from 'react';
import * as Header from '../constants/Header';
import SignForm from '../containers/SignForm';

import '../common/css/reset.css';
import '../common/css/cmn_layout.css';
import '../common/css/cmn_style.css';
import '../css/login.css';

class Description extends React.Component {
  render() {
    return (
      <div className="description">
        <style type="text/css">
        {'h1 { font-weight: bold; }'}
        {'#wrapper .contentIn { width: 670px; padding: 185px 0 22px; }'}
        </style>
        <p>モフトレ・ダッシュボードにログインできない時は…</p>
        <p>ログインできない原因としては、IDやパスワードを入力にミスがあるのかもしれません。</p>
        <p>&nbsp;</p>
        <p>以下のような要因が考えられます。</p>
        <p>*大文字と小文字が正しく入力されていない</p>
        <p>*全角での入力になってしまっている</p>
        <p>*数字を入力したつもりが、テンキー入力(数字のキーボード)が無効になっている</p>
        <p>*IDやパスワードにスペースが入力されてしまっている</p>
        <p>&nbsp;</p>
        <p>ログインできない時は、焦らずに上記の可能性をしっかりと確認し、それでもログインできない際はモフトレのカスタマーサポートに問い合わせるようにしましょう。</p>
      </div>
    );
  }
}

interface LoginProps extends React.Props<{}> {
  headerActions?: any;
}

class Login extends React.Component<LoginProps, {}> {
  constructor (props: any) {
    super(props);
  }
 
  componentWillMount() {
    document.title = 'モフトレ・ダッシュボード';

    this.props.headerActions.setPage(Header.LOGIN);
  }

  render() {
    return ([
      <SignForm key="signForm" />,
      <Description key="desc" />
    ]);
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login.tsx